module.exports = __webpack_public_path__ + "static/img/jj2.556c9af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/jj2.png
// module id = jHxF
// module chunks = 13